import { shallowEqual, useSelector } from 'react-redux'
import { AsideMenuItem } from '../AsideMenuItem'
import { RootState } from '../../../../../setup'
import { UserModel } from '../../../../../app/modules/auth/models/UserModel'
import { hasPermission, hasRole } from '../../../../../app/utils/permissions'
import { Permission, UserRole } from '../../../../../app/constants/roles'

export function MenuAdmin() {
    const user = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel
    const canWaitList = hasPermission(user, Permission.MANAGE_WAITLIST_ADMIN)
    const canManageMember = hasPermission(user, Permission.MANAGE_MEMBER)
    const canExperiencesAdmin = hasPermission(user, Permission.EXPERIENCE_ADMIN)
    const canManageAdmins = hasPermission(user, Permission.MANAGE_ADMIN)
    const canManagePartner = hasPermission(user, Permission.MANAGE_PARTNER)
    const canDashboardAdmin = hasPermission(user, Permission.DASHBOARD_ADMIN)
    const canManagePayouts = hasPermission(user, Permission.MANAGE_PAYOUTS)
    const canManageCommissions = hasPermission(user, Permission.MANAGE_COMMISSIONS)
    const canManageAuditLog = hasPermission(user, Permission.MANAGE_AUDIT_LOG)
    const canManageFinancial = canManagePayouts || canManageCommissions
    const isAdmin = hasRole(user, UserRole.ADMIN)
    /* hardcore permission */
      const isRenee = user.id == 32 // hardcode Renee's user ID to hide staging
    // const isRenee = user.id == 14 // hardcode Renee's user ID to hide production
    /* end hardcore */

    return (<div className='nb-aside-content'>
        <div className='nb-menu-section'>
            <div className='nb-menu-section-content'>
                {canManageAdmins && (<AsideMenuItem to='/dashboard/admin' title='Dashboard' showIcon={true} icon='/media/icons/duotune/general/dashboard.svg' />)}
            </div>
        </div>
        <div className='nb-menu-section'>
            <div className='nb-menu-section-header'>
                <span className='nb-menu-section-title'>Management</span>
            </div>
            <div className='nb-menu-section-content'>
                {/* <AsideMenuItem to='/admin/introduction' title='Introductions' showIcon={true} icon='/media/svg/nobilis/admin-menu-gray.svg' /> */}
                {canManageAdmins && !isRenee && (<AsideMenuItem to='/manage-admins' title='ADMINS' showIcon={true} icon='/media/svg/nobilis/admin-menu-gray.svg' />)}
                {canManageMember && (<AsideMenuItem to='/manage-members' title='MEMBERS' showIcon={true} icon='/media/svg/nobilis/member-menu-gray.svg' />)}
                {canManagePartner && !isRenee && (<AsideMenuItem to='/manage-partners' title='PARTNERS' showIcon={true} icon='/media/svg/nobilis/partner-menu-gray.svg' />)}
            </div>
        </div>
        <div className='nb-menu-section'>
            <div className='nb-menu-section-header'>
                <div className='separator_menu'></div>
                <span className='nb-menu-section-title'>Review</span>
            </div>
            <div className='nb-menu-section-content'>
                {canWaitList && (<AsideMenuItem to='/waitinglist' title='waitlist' showIcon={true} icon='/media/svg/nobilis/waitlist-menu-gray.svg' />)}
                <AsideMenuItem to='/introductions' title='Introductions' showIcon={true} icon='/media/svg/nobilis/exp_nb.svg' />
                {canExperiencesAdmin && (<AsideMenuItem to='/experience/admin' title='Experiences' showIcon={true} icon='/media/svg/nobilis/experience-menu-gray.svg' />)}
                {isAdmin && (<AsideMenuItem to='/expertise' title='Expertise' showIcon={true} icon='/media/svg/nobilis/experience-menu-gray.svg' />)}
                <AsideMenuItem to='/admin/community' title='Community' showIcon={true} icon='/media/svg/nobilis/admin-community.svg' />
            </div>
        </div>
        {canManageFinancial && (
            <div className='nb-menu-section'>
                <div className='nb-menu-section-header'>
                    <div className='separator_menu'></div>
                    <span className='nb-menu-section-title'>Financial</span>
                </div>
                <div className='nb-menu-section-content'>
                    {canManagePayouts && (<AsideMenuItem to='/admin/payouts' title='Partner Payouts' showIcon={true} icon='/media/svg/nobilis/experience-menu-gray.svg' />)}
                    {canManageCommissions && (<AsideMenuItem to='/admin/commissions' title='Commission Rates' showIcon={true} icon='/media/svg/nobilis/experience-menu-gray.svg' />)}
                </div>
            </div>
        )}
        {canManageAuditLog && (
            <div className='nb-menu-section'>
                <div className='nb-menu-section-header'>
                    <div className='separator_menu'></div>
                    <span className='nb-menu-section-title'>Compliance</span>
                </div>
                <div className='nb-menu-section-content'>
                    <AsideMenuItem to='/admin/audit-log' title='Audit Log' showIcon={true} icon='/media/svg/nobilis/experience-menu-gray.svg' />
                </div>
            </div>
        )}
        {isAdmin && (
            <div className='nb-menu-section'>
                <div className='nb-menu-section-header'>
                    <div className='separator_menu'></div>
                    <span className='nb-menu-section-title'>Configurations</span>
                </div>
                <div className='nb-menu-section-content'>
                    <AsideMenuItem to='/admin/banners' title='Banners Dashboard' showIcon={true} icon='/media/svg/nobilis/experience-menu-gray.svg' />
                    {/* One "Catalogs" entry drives the unified admin surface; the in-page picker
                        switches between beneficiaries / categories / audiences / durations /
                        confidentiality / sensitive fields. Deep-link URLs (/admin/catalog/:slug)
                        still work for bookmarks. */}
                    <AsideMenuItem to='/admin/catalog' title='Catalogs' showIcon={true} icon='/media/svg/nobilis/experience-menu-gray.svg' />
                </div>
            </div>
        )}
        {isAdmin && (
            <div className='nb-menu-section'>
                <div className='nb-menu-section-header'>
                    <div className='separator_menu'></div>
                    <span className='nb-menu-section-title'>Loyalty</span>
                </div>
                <div className='nb-menu-section-content'>
                    <AsideMenuItem to='/admin/catalog/member-balances' title='Member Balances' showIcon={true} icon='/media/svg/nobilis/experience-menu-gray.svg' />
                </div>
            </div>
        )}
    </div>)
}
